<template>
  <v-app id="agentCom">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="4">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
          </v-col>
      </v-row>
     
      <v-row>    
          <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="submitted" @click="ovrz">Create excel sheet</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      bedrCodesSelected: [],
      bedrCodes: [],
      selectCodesSelected: '',
      selectCodes: [],
      submitted: false,
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/task/fin/ovrz/getHoctParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHoctParam"
        },
        getHoctParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getHoctParam; 
           res.data.getHoctParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.submitted = true;
      this.$axios
        .post("ares/json/ares/task/fin/ovrz/excelExportHoct1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportHoct"
          },
          excelExportHoct: {
            bedr_codes: this.bedrCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {

            this.submitted = false;
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportHoct.text,
              color: res.data.excelExportHoct.color,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
